import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';

@Component({
  selector: 'app-addfoodsymbol',
  templateUrl: './addfoodsymbol.component.html',
  styleUrls: ['./addfoodsymbol.component.css']
})
export class AddfoodsymbolComponent implements OnInit {

  //Mode Values
  isaddmode:boolean=false;
  iseditmode:boolean=false;
  isdeletemode:boolean=false;
  isviewmode:boolean=false;
  
  //Save Validation
  submitted:boolean;
  successfully:boolean;
  
  
  //Edit Get Values
  foodsymbolColl:any=[];
  foodsymbolid:number=0
  
  //pageColl:any=[];
  
  foodsymbolform=new FormGroup({        
    foodsymbolid:new FormControl(0),      
    foodsymbolname:new FormControl('',Validators.required), 
    foodsymbolcolor:new FormControl('',Validators.required),   
    inactive:new FormControl(false),     
  });
  
  isloading:boolean=false;
  isprivilage:boolean=false;  
  showProgress:boolean=false;
  formname:String="Foodsymbol";
  
  constructor(private appService: DhukanDataService,private route: ActivatedRoute,
     public router: Router,private toastr: ToastrService,private loginService:LoginDataService) { 
       this.route.queryParams.subscribe(params => {
        if(params.id!==undefined){
          this.foodsymbolid = params.id
        }  
       });
       this.fnServiceChanges();
  }
  
  
  fnServiceChanges(){
    this.loginService.serviceloginChange.subscribe((value) => {
          if(this.loginService.fnCheckUser()){
           
            if(this.fnCheckUserPririvilage()){
              this.isloading=true;
              this.fnOnInitForm();
            }
            else{
              this.fnUserFailedForm();
            }
              
          }
          else{
            this.fnUserFailedForm();
          }
    });
  }
  
  ngOnInit() {
      try{
        if(this.loginService.fnCheckUser()){ 
          if(this.fnCheckUserPririvilage()){       
            this.isloading=true;
            this.fnOnInitForm();
          }
          else{
            this.fnUserFailedForm();
          }
        }
        else{
          this.loginService.fnGetUserRoleList();
        }
                
      }catch(ex){
        this.fnShowErrorMsg(ex);
      }
  }
  
  fnOnInitForm(){
     try{
         this.isaddmode=true;
         this.foodsymbolform.reset();
         this.fnInitializeFoodsymbol(); 
  
         if(this.foodsymbolid>0){
           this.fngetFoodsymbol();
         }       
  
     }catch(ex){
       this.fnShowErrorMsg(ex);
     }
  }
  
  
  
  fnCheckUserPririvilage(){
    var _check:boolean=false;
    if (this.foodsymbolid>0){
      _check= this.loginService.fnCheckUserRoleAction(this.formname,'ALTER')
    }else{
      _check= this.loginService.fnCheckUserRoleAction(this.formname,'CREATE')
    }
  
    return _check;
  }
  
  fnUserFailedForm(){
    this.isprivilage=true;
  }
  
  
  fnInitializeFoodsymbol(){
     this.foodsymbolform.setValue({
       
      foodsymbolid:0, 
      foodsymbolname:'', 
      foodsymbolcolor:'',    
      inactive:false,      
     })
  }
  
  
  
  
  //Get 
  fngetFoodsymbol() {        
       var data = {
         'foodsymbolid':this.foodsymbolid,            
       }
       this.appService.getFoodsymbol(data)
       .subscribe(
         (res)=>{                  
           this.foodsymbolColl=res.json().result;
           var editdata =this.foodsymbolColl[0];
           console.log(editdata)
           this.fnEditMode(editdata);
       },
       (err)=>{          
         this.toastr.error('Error', err);
       })
  }
  
  
  
  
  //Save Btn Click
  fnSaveBtnClick(){
     try{
       this.submitted=true;
       this.successfully=false;
       //Validate
       if(this.foodsymbolform.valid){
           //Check
           var data = {
                 'foodsymbolid': this.foodsymbolid,                   
                 'foodsymbolname':this.foodsymbolform.get('foodsymbolname').value, 
                 'foodsymbolcolor':this.foodsymbolform.get('foodsymbolcolor').value,               
                 'inactive':this.foodsymbolform.get('inactive').value,     
                 'createdby': this.loginService.fnGetModUserId(),    
                 'modifiedby':this.loginService.fnGetModUserId(), 
           }
           this.appService.fnCheckFoodsymbol(data).subscribe(
             (res)=>{
                 var _checkresult=res.json().result[0].checkfield;
               
                 if(_checkresult==="done"){
                       if (this.foodsymbolform.get('foodsymbolid').value>0){
                         //Update Department
                         this.fnSetFoodsymbol(data);
                       }
                       else{
                         //Insert Department
                         this.fnInsertFoodsymbol(data);
                       }
                 }
                 else{        
                       if(_checkresult==="name"){
                         this.foodsymbolform.controls['foodsymbolname'].setErrors({'notfound': true});
                       }
                 }
           },
           (err)=>{
               this.toastr.error('Error', err);           
           });
        }
     }catch(ex){
       this.fnShowErrorMsg(ex);
     }
  }
  
  //Insert
  fnInsertFoodsymbol(data){    
   
     this.appService.fnInsertFoodsymbol(data).subscribe(
       (res)=>{
       if(res.json().result!=""){
         this.toastr.success('', "The new foodsymbol has been added successfully.Insert Successfully");
  
         this.fnInsertActivityLog('INSERT',0,data.foodsymbolname);
  
         this.fnCloseFoodsymbol();
       }},
       (err)=>{
         this.toastr.error('Error', err);
       });
  
  }
  
  //Set
  fnSetFoodsymbol(data){    
  
  this.appService.fnSetFoodsymbol(data).subscribe(
   (res)=>{
   if(res.json().result!=""){
       this.toastr.success('', "The foodsymbol has been updated successfully.");
  
       this.fnInsertActivityLog('EDIT',this.foodsymbolid,data.foodsymbolname);
  
       this.fnCloseFoodsymbol();        
   }},
   (err)=>{
     this.toastr.error('Error', err);
   });
  
  }
  
  //Close
  fnCloseFoodsymbol(){
  try{
    this.router.navigate(['/Foodsymbol']);
  }catch(ex){
     this.fnShowErrorMsg(ex);
  }
  }
  
  private fnEditMode(deptBO){
  console.log(deptBO)
   this.foodsymbolform.setValue({

    foodsymbolid:deptBO.foodsymbolid,
    foodsymbolname:deptBO.foodsymbolname,
    foodsymbolcolor:deptBO.foodsymbolcolor,
        inactive:deptBO.inactive,   
   });
  
  
  this.isaddmode=false;
  this.iseditmode=true;
  this.isdeletemode=false;
  this.isviewmode=false;
  }
  
  
  fnInsertActivityLog(action,refno,desc){
    try{
      var data={
        logtype:action,
        logat:this.formname,
        refnum:refno,
        logdescr:desc,
        logby:this.loginService.fnGetModUserId(),
      }
    
  
      // this.appService.fnInsertActivity(data).subscribe(
      //   (res)=>{
      //   },
      //   (err)=>{
       
      //   });
  
    }catch{
  
    }
  }
  
  
  
  private fnShowProgress(){
    this.showProgress=true;
  }
  private fnHideProgress(){
    this.showProgress=false;
  }
  
  private  fnShowErrorMsg(ex){
  this.toastr.warning('Internal Error', ex);       
  }
  
  
  
  
  
  }
  